module.exports = __webpack_public_path__ + "static/architecture-bungalow-6ae1ac7a1e3cb88bbf7d378bdb278f2a.jpg";